import FormSelect from '../FormSelect'
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  extends: FormSelect,
  computed: {
    ...mapGetters([ 'buildingById', 'buildingsArray' ]),
    normalizedOptions () {
      return this.buildingsArray.map(el => el.id)
    },
  },
  created () {
    store.dispatch('loadBuildings')
  },
  methods: {
    normalizedOptionLabel (option) {
      if (!option) return ''
      return this.buildingById(option).displayName || 'Building Not Found'
    },
  },
}
